import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SkillPersistenceService } from '../../../services/skill-persistence.service';
import { SkillConstants } from '../../../constants/skill-constants';
import { EqmsScopeManagementService } from '../../../../shared/services/eqms-scope-management.service';

@Component({
  selector: 'app-skill-training-item-slider',
  templateUrl: './skill-training-item-slider.component.html',
  styleUrls: ['./skill-training-item-slider.component.scss']
})
export class SkillTrainingItemSliderComponent  implements OnInit{
  @Output() isTrainingItemSliderActive = new EventEmitter<boolean>();
  @Input() isTrainingItemSliderOpen: boolean = false;
  @Input() skillScopes: any = [];
  @Input() skillCode !: string;
  errorIconClassForDocumentTab = '';
  errorIconClassForCourseTab = '';
  currentTab = 0;
  activeTab = 0;
  constructor(private skillPersistenceService : SkillPersistenceService, private eQMSPersistenceService : EqmsScopeManagementService){

  }

  ngOnInit(): void {
    this.skillPersistenceService.closeAndResetTrainingItemSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetSkillSlider(); }
    });

    this.skillPersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
    this.getScopeAncestors();
  }

  closeSlider(){
    this.skillPersistenceService.openConfirmationDialog();
  }

  closeAndResetSkillSlider(){
    this.isTrainingItemSliderOpen = false;
    this.activeTab = 0;
    this.currentTab = 0;
    this.skillPersistenceService.onTabChange(-1);
    this.skillPersistenceService.onCustomTabChange(-1);
    this.isTrainingItemSliderActive.emit(this.isTrainingItemSliderOpen);
  }

  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }
  onTabChange = (event: any) => {
    this.skillPersistenceService.onTabChange(this.currentTab);
    this.skillPersistenceService.onCustomTabChange(event.index);
    this.currentTab = event.index;
  }
  showErrorIconForTab = () => {
    this.errorIconClassForDocumentTab = '';
    this.errorIconClassForCourseTab = '';
    this.skillPersistenceService.errorTabIndices.forEach((tabIndex) => {
      switch (tabIndex) {
        case SkillConstants.Skill_Menu_Document_Tab_Index:
          this.errorIconClassForDocumentTab = 'pi pi-exclamation-triangle';
          break;
        case SkillConstants.Skill_Menu_Course_Tab_Index:
          this.errorIconClassForCourseTab = 'pi pi-exclamation-triangle';
          break;
      }
    })
  }
  
  getScopeAncestors = () => {
    this.eQMSPersistenceService.geteQMSScopeAncestors(this.skillScopes).subscribe((response) => {
      this.skillScopes = this.skillScopes.concat(response);
    });
  }
}
